import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@thinglogix/ngx-foundry-core';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const MIN_USERNAME_LENGTH = 3;
const MIN_PASSWORD_LENGTH = 8;

@Component({
    templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit, OnDestroy {
    isLoader = false;

    isLoadingMode = true;

    loginError = '';

    loginForm!: FormGroup;

    readonly NoWhitespaceRegExp: RegExp = new RegExp('\\S');

    private ngUnsubscribe = new Subject();

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private router: Router
    ) {}

    ngOnInit(): void {
        //we are checking maxlength , white space and blank value on this validation

        this.loginForm = this.fb.group({
            account: [environment.liquidInsightAccountId, Validators.required],
            username: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.NoWhitespaceRegExp),
                    Validators.minLength(MIN_USERNAME_LENGTH),
                ],
            ],
            password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(MIN_PASSWORD_LENGTH),
                ],
            ],
        });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(undefined);
        this.ngUnsubscribe.complete();
    }

    /**
     * Calls the login API using the form value
     *
     * @returns {Promise<void>} Promise with void value after the API has been called
     */
    async login(): Promise<void> {
        const account: string = this.loginForm.value.account;
        const username: string = this.loginForm.value.username.trim();
        const password: string = this.loginForm.value.password;

        this.isLoader = true;
        this.loginError = '';

        this.authService
            .authorize(account, username, password, true)
            .pipe(
                takeUntil(this.ngUnsubscribe),
                finalize(() => {
                    this.isLoader = false;
                })
            )
            .subscribe(
                (data: any) => {
                    //Sucess Response
                    console.log(data);
                    this.router.navigate(['/inventory']);
                },
                (error) => {
                    //Error Response
                    this.loginError = error.response.data.error;
                }
            );
    }
}
